import Vue from 'vue'
import urlConfig from '../configs/url-config'
import fetchUtil from '@/util/fetchUtil'
import authHeaderUtil from '../util/authHeaderUtil'
import { addToMailingList } from './mailingList'

export default {
  updateIdTokenClaims: async () => {
    const url = `${urlConfig.functionsBaseUrl}/account/update-claims`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const response = await fetchUtil.request({
      method: 'PUT',
      url,
      headers: authHeader.headers
    })
    if (response.status < 200 || response.status >= 400) {
      Vue.logger.error(new Error(`Failed to update claims ${response.status}`))
    }
  },

  getSubscriptionExpiration: async () => {
    const url = `${urlConfig.functionsBaseUrl}/account/subscription-expiration`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const response = await fetchUtil.request({
      url,
      headers: authHeader.headers
    })
    let expirationDate
    if (response.ok) {
      const { isFree, expiration } = await response.json()
      if (!isFree && expiration) {
        expirationDate = new Date(expiration)
      }
    }
    return expirationDate
  },

  verifyDiscourseAuth: async (data) => {
    const url = `${urlConfig.functionsBaseUrl}/verifyDiscourseAuthRequest`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const response = await fetchUtil.request({
      method: 'POST',
      url,
      headers: authHeader.headers,
      data
    })
    if (!response.ok) {
      throw new Error(`Unexpected response ${response.status}`)
    }
    const { redirect } = await response.json()
    return redirect
  },

  addToFreeTrialSignup: async (data) => addToMailingList('free-trial-signup', data),
  addToPayInterestList: async (data) => addToMailingList('interested-in-subscription', data),

  isFreeTrialAvailable: async () => {
    const url = `${urlConfig.functionsBaseUrl}/account/free-trial-status`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const response = await fetchUtil.request({
      method: 'GET',
      url,
      headers: authHeader.headers
    })
    if (!response.ok) {
      throw new Error(`Unexpected response ${response.status}`)
    }

    const result = await response.json()
    return result.isAvailable
  },

  activateFreeTrial: async () => {
    const url = `${urlConfig.functionsBaseUrl}/account/start-free-trial`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const response = await fetchUtil.request({
      method: 'POST',
      url,
      headers: authHeader.headers
    })
    if (!response.ok) {
      throw new Error(`Unexpected response ${response.status}`)
    }

    const result = await response.json()
    return result.isStarted
  },

  redeemFreePassPromo: async (freePassCode) => {
    const url = `${urlConfig.functionsBaseUrl}/freePass/redeem/${freePassCode}`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const response = await fetchUtil.request({
      method: 'POST',
      url,
      headers: authHeader.headers
    })
    if (!response.ok) {
      throw new Error(`Unexpected response ${response.status}`)
    }

    if (response.status !== 201) {
      const result = await response.json()
      return result.error
    }
  },

  async saveAlertHideDay6BuildTimeEstimate (hide) {
    const url = `${urlConfig.functionsBaseUrl}/account/account-alert`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const data = { hideDay6BuildEst: !!hide }
    const response = await fetchUtil.request({
      method: 'PUT',
      url,
      headers: authHeader.headers,
      data
    })

    if (response.status < 200 || response.status > 399) {
      Vue.logger.log(`Unexpected save alert preferences response ${response.status}`)
    }
  }
}
